module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp1_5012.3c4ddc54.png";